export async function checkVersion() {
  try {
    const res = await fetch("/version.json", {
      cache: "no-cache",
    });
    const data = await res.json();

    const storedVersion = localStorage.getItem("app-version");

    if (storedVersion && storedVersion !== data.version) {
      localStorage.setItem("app-version", data.version);

      window.location.reload(true);
    } else {
      localStorage.setItem("app-version", data.version);
    }
  } catch (error) {
    console.error("Version check failed:", error);
  }
}
